import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconImageBroken';
/** Renders an SVG icon. */
const SvgImageBroken = ({
  size,
  'aria-hidden': ariaHidden,
  tone,
  UNSAFE_className,
  UNSAFE_style,
  ...rest
}: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        d="M26 11h-2a1 1 0 0 0-.895.553l-1.782 3.563-4.52.904a1 1 0 0 0-.784.784l-.904 4.52-.303.153-4.198-3.266a1 1 0 0 0-1.357.12L6 21.951V8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2zm-13 .5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M26 24a2 2 0 0 1-2 2h-5.001l1.6-1.2.077-.064a1 1 0 0 0 .314-.594l.394-2.757 2.758-.395.096-.02a1 1 0 0 0 .562-.37L26 19zM8 26a2 2 0 0 1-1.85-1.241 1 1 0 0 0 .093-.09l3.877-4.308 2.71 2.107-1.277.637A1 1 0 0 0 11 24v2zM28 8a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v16a4 4 0 0 0 4 4h4a1 1 0 0 0 1-1v-2.382l3.447-1.723.1-.058a1 1 0 0 0 .433-.64l.87-4.346 4.346-.87.112-.03a1 1 0 0 0 .587-.504L24.617 13H27a1 1 0 0 0 1-1zm-13 3.5a3.5 3.5 0 1 0-7 0 3.5 3.5 0 0 0 7 0M28 16a1 1 0 0 0-1.8-.6l-2.75 3.668-3.092.442a1 1 0 0 0-.848.848l-.443 3.092L15.4 26.2A1 1 0 0 0 16 28h8a4 4 0 0 0 4-4z"
      />
    </svg>
  );
};
SvgImageBroken.displayName = displayName;
export default SvgImageBroken;
